import { Box, Button, Text, theme } from "@bpba/ui-components";
import { useEffect, useRef } from "react";

type ResultProps = {
  callback: () => void;
  info: [string, string];
};

export const Result = (props: ResultProps) => {
  const focusOn = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    focusOn.current?.scrollIntoView(false);
    focusOn.current?.focus();
  }, []);

  return (
    <>
      <Text
        fontSize={"1.5rem"}
        lineHeight={"1.8rem"}
        color={theme.colors.primary[0]}
        fontWeight={600}
      >
        {props.info[0]}
      </Text>
      <Box my={"24px"}>
        <div dangerouslySetInnerHTML={{ __html: props.info[1] }} />
      </Box>
      <Button
        type={"submit"}
        fontSize={"15px"}
        variant={"secondary"}
        padding={"12px !important"}
        mt={"24px !important"}
        onClick={props.callback}
        ref={focusOn}
      >
        <Text lineHeight={"25px"} m={"0px"}>
          Ir al inicio
        </Text>
      </Button>
    </>
  );
};
